import React from 'react';
import Header from '../Components/Header';
import TopBanner from '../Components/TopBanner';
import WhyParticipate from '../Components/WhyParticipate';
import ElevateBusiness from '../Components/ElevateBusiness';
import KeyFeatures from '../Components/KeyFeatures';
import ConsultationCTA from '../Components/ConsultationCTA';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';

function Home() {
  return (
    <div>
      <Helmet>
        <title>MobileAcc Expo | B2B Mobile & Accessories Exhibition</title>
        <meta
          name="description"
          content="MobileAcc Expo – India's premier B2B mobile and accessories exhibition at Bharat Mandapam, Pragati Maidan, New Delhi."
        />
      </Helmet>

      <Header />
      <TopBanner />
      <WhyParticipate />
      <ElevateBusiness />
      <KeyFeatures />
      <ConsultationCTA />
      <Footer />
    </div>
  );
}

export default Home;
